<div class="row" *ngIf="data">
  <div class="col-12 mb-3">
    <a
      class="btn btn-iconed btn-iconed-primary w-auto"
      [download]="data.Filename"
      [href]="data.Base64Result | safeUrl"
      target="_blank"
      >{{ data.DownloadLabel }}&nbsp;<i
        aria-hidden="true"
        class="btn-icon ifc-custom ifc-download"
      ></i
    ></a>
  </div>

  <div class="col-12 d-flex justify-content-center align-items-center">
    <embed
      [src]="data.Base64Result | safeUrl"
      [attr.type]="data.IsPdf ? 'application/pdf' : 'image/png'"
      [attr.width]="data.IsPdf ? '600px' : '400px'"
      [attr.height]="data.IsPdf ? '400px' : 'auto'"
    />
  </div>
</div>
